module.exports = __webpack_public_path__ + "img/matrizPagos.7f628063.svg";